
import { UseFormRegister, UseFormWatch, UseFormSetValue } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { Application } from '@/types/database.types';
import { BasicCompanyInfo } from './company-sections/BasicCompanyInfo';
import { IdentificationInfo } from './company-sections/IdentificationInfo';
import { CorporateStructureInfo } from './company-sections/CorporateStructureInfo';

interface CompanyInformationProps {
  register: UseFormRegister<Partial<Application>>;
  watch: UseFormWatch<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
  data: Partial<Application>;
}

export const CompanyInformation = ({ 
  register, 
  watch, 
  setValue, 
  data 
}: CompanyInformationProps) => {
  return (
    <div className="space-y-6">
      {/* Basic Company Information Section */}
      <BasicCompanyInfo 
        register={register}
      />
      
      {/* Identification Information Section */}
      <IdentificationInfo 
        register={register}
      />
      
      {/* Corporate Structure Information Section */}
      <CorporateStructureInfo 
        register={register}
        setValue={setValue}
        data={data}
      />
    </div>
  );
};

